import { ArtistByIdInfo } from "models/artists/EntityModels"
import { HeadlinerInfo } from "models/headliners/EntityModels"
import { socials } from 'constants/socials'
import { ExpertByIdInfo } from "models/experts/EntityModels"

export const getSocials = (person: ArtistByIdInfo | ExpertByIdInfo | HeadlinerInfo) => {
  return Object.keys(socials).map((social, i) => {
    const socialUrl = `${social}Url`
    return (
      person[socialUrl] && (
        <a key={i} href={person[socialUrl]}>
          <img src={`/svgs/${socials[social]}.svg`} />
        </a>
      )
    )
  })
}

export const getRusGenre = {
  metal: 'Металл',
  classic: 'Классика',
  rock: 'Рок',
  pop: 'Поп',
  electro: 'Электро',
  hiphop: 'Хип-Хоп',
  folk: 'Фолк',
  jazz: 'Джаз'
}

export const getFullPlace = (country: string | undefined, city: string | undefined): string => {
  if (country && city) {
    return `${country} / ${city}`
  }
  if (country) {
    return country
  }
  if (city) {
    return city
  }

  return ''
}
